import { render, staticRenderFns } from "./card-meuspedidos.vue?vue&type=template&id=566b17e1&scoped=true"
import script from "./card-meuspedidos.vue?vue&type=script&lang=js"
export * from "./card-meuspedidos.vue?vue&type=script&lang=js"
import style0 from "./card-meuspedidos.vue?vue&type=style&index=0&id=566b17e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b17e1",
  null
  
)

export default component.exports